// extracted by mini-css-extract-plugin
export default {"resultContainer":"Search_resultContainer__B-vFw"};